import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React from 'react';

const ProductGroupIcon = ({
	alt,
	className,
	groups,
	type = 'list',
	...props
}) => {
	const types = {
		card: 'icon-xxl',
		list: 'icon-lg pe-1',
		product_img: 'img-fluid',
	};

	const group_id = groups && groups.length == 1 ? groups[0] : null;
	const result = useStaticQuery(graphql`
		query ProductGroupIcon {
			allGroup(filter: { files: { elemMatch: { symbol: { eq: "icon" } } } }) {
				nodes {
					fields {
						files_icon_url_src {
							childImageSharp {
								gatsbyImageData(width: 640)
							}
						}
					}
					files {
						url
					}
					group_id
				}
			}
		}
	`);

	const group = result.allGroup.nodes.find(
		(value) => value.group_id == group_id,
	);

	const image = group?.fields?.files_icon_url_src;

	if (!group || !image) return <></>;

	return (
		<>
			<GatsbyImage
				alt={alt}
				className={`${types[type]} ${className}`}
				draggable="false"
				image={getImage(image)}
				{...props}
			/>
		</>
	);
};

ProductGroupIcon.propTypes = {
	alt: PropTypes.string,
	className: PropTypes.string,
	groups: PropTypes.array,
	type: PropTypes.string,
	variant: PropTypes.string,
};

export default ProductGroupIcon;
